import { default as sliders } from '../../../assets/src/js/modules/_sliders.js';

( function( $ ) {

	/**
	 * initializeBlock
	 *
	 * Adds custom JavaScript to the block HTML.
	 *
	 * @date    15/4/19
	 * @since   1.0.0
	 *
	 * @param   object $block The block jQuery element.
	 * @param   object attributes The block attributes (only available when editing).
	 * @return  void
	 */
	var initializeBlock = function( $block ) {

		console.log( 'Slider: Do some stuff on block preview initialization.' );

		var singleSlider = $block[0].querySelector('.js-video-slider')

		if ( singleSlider ) {
			sliders.setupVideoSlider( singleSlider );
		}

	}


	// Initialize each block on page load (front end).
	jQuery( document ).ready(function() {

		const pageSliders = document.querySelectorAll( '.js-video-slider' );

		if ( pageSliders ) {
			pageSliders.forEach( ( element ) => {
				sliders.setupVideoSlider( element );
			});
		}

	});


	// Initialize dynamic block preview (editor).
	if( window.acf ) {
		window.acf.addAction( 'render_block_preview/type=video-slider', initializeBlock );
	}

})( jQuery );